import type { IconProps } from './icon.types'

const EyeOffIcon = (props: IconProps) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='eye-off-icon'
    {...props}
  >
    <path d='M3 3.5l12 11' />
    <path d='M6.4 5.6C3.7 6.9 1.5 9 1.5 9s3 5 7.5 5c1.4 0 2.6-.3 3.7-.8' />
    <path d='M14.6 12.3C15.8 11.2 16.5 9 16.5 9S13.5 4 9 4c-.7 0-1.4.1-2 .3' />
    <path d='M7.3 7.5a2.4 2.4 0 0 0 3.4 3.4' />
  </svg>
)

export default EyeOffIcon
